import { KitType } from '@repo/types';
import { ComponentProps } from 'react';
import ConditionMetricCard from '../../ConditionMetricCard';

type EvaluationCounts = ComponentProps<
  typeof ConditionMetricCard
>['evaluationCounts'];

export const CARD_CONFIG: Record<
  KitType,
  { name: string; evaluationCounts: EvaluationCounts }
> = {
  vaginal: {
    name: 'Bacterial vaginosis (BV)',
    evaluationCounts: {
      great: 1,
      okay: 0,
      improve: 3,
      support: 2,
    },
  },
  stool: {
    name: 'Food allergies',
    evaluationCounts: {
      great: 6,
      okay: 3,
      improve: 1,
      support: 2,
    },
  },
};
